import { render, staticRenderFns } from "./DefaultContainer.vue?vue&type=template&id=ec03c422&scoped=true&"
import script from "./DefaultContainer.vue?vue&type=script&lang=js&"
export * from "./DefaultContainer.vue?vue&type=script&lang=js&"
import style0 from "./DefaultContainer.vue?vue&type=style&index=0&id=ec03c422&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec03c422",
  null
  
)

export default component.exports